import { render } from "./ButtonCancelClose.vue?vue&type=template&id=f9b2e268"
import script from "./ButtonCancelClose.vue?vue&type=script&lang=js"
export * from "./ButtonCancelClose.vue?vue&type=script&lang=js"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__